module.exports = __webpack_public_path__ + "img/avatar.1910d4f6.svg";